<template>
  <el-col :span="24">
    <header class="el-drawer__header nanw_khan">
      <span title="Новый заказ">{{ $t("message.product") }}</span>
      <el-button
          type="warning"
          icon="el-icon-close"
          size="small"
          @click="close"
      >{{ $t("message.close") }}</el-button
      >
    </header>
    <el-card class="m-3 padding_table">
      <table class="table" v-loading="loading">
        <thead>
        <tr>
          <th scope="col">{{ $t("message.name") }}</th>
          <th scope="col">{{ $t("message.remainder") }}</th>
          <th scope="col">{{ $t("message.warehouse") }}</th>
          <th scope="col">{{ $t("message.day_in_warehouse") }}</th>
          <th scope="col">{{ $t("message.days_before_expiration") }}</th>
          <th scope="col">{{ $t("message.price2") }}</th>
          <th scope="col">{{ $t("message.term") }}</th>
          <th scope="col">{{ $t("message.serial_number") }}</th>
          <th scope="col">{{ $t("message.date_receiving") }}</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(item, index) in warehouse_products"
            :key="'warehouse_products-' + index"
            :style="expireColor(item)"
        >
          <td>{{ item.product ? item.product.name : "" }}</td>
          <td>{{ item.remainder }}</td>
          <td>{{ item.warehouse ? item.warehouse.name : "" }}</td>
          <td>{{ daysInWarehouse(item) }}</td>
          <td>{{ expireDays(item) }}</td>
          <td>{{ item.price }}</td>
          <td>{{ item.expiration_date }}</td>
          <td>{{ item.serial_number ? item.serial_number : '-' }}</td>
          <td>{{ item.received_date }}</td>
        </tr>
        </tbody>
      </table>
    </el-card>
  </el-col>
</template>

<script>
import {mapActions} from "vuex";
import drawerChild from "@/utils/mixins/drawer-child";
import {i18n} from "@/utils/i18n";
import {isNumber} from "lodash";

export default {
  mixins: [drawerChild],
  props: ["product", "warehouseId"],
  data() {
    return {
      loading: false,
      warehouse_products: [],
    };
  },
  methods: {
    ...mapActions({
      showWarehouseProducts: "warehouseProducts/index",
    }),
    afterOpened() {
      this.showWarehouseProducts({expires: true})
        .then((response) => {
          this.warehouse_products = response.data.warehouseProducts.data;
          this.loading = false;
      });
    },
    daysInWarehouse(item) {
      const currentDate = new Date();
      const date = new Date(item.manufactured_date);

      const diffMs = currentDate - date;
      return Math.floor(diffMs / (1000 * 3600 * 24));
    },
    expireDays(item) {
      const currentDate = new Date();
      const expirationDate = new Date(item.expiration_date);

      const diffMs = expirationDate - currentDate;
      const diffDays = Math.floor(diffMs / (1000 * 3600 * 24)) + 2
      if (diffDays <= 0) {
        return i18n.t(`message.expired`)
      } else {
        return diffDays;
      }
    },
    expireColor(item) {
      return isNumber(this.expireDays(item)) ? 'background-color: transparent' : 'background-color: rgba(255, 0, 0, 0.3)';
    }
  },
};
</script>
